export default __webpack_public_path__ + "static/144-c32ee7b9e686df3c849c53b5f375edc7.jpg";